import { useGetDriverByIdQuery } from "@/libs/generated/hooks";

function useDriverDetails(id: number) {
  if (!id) throw new Error("Invalid driver id");

  return useGetDriverByIdQuery(
    { GetByIdInput: { id: Number(id) } },
    { select: (data) => data.getDriverById }
  );
}

export { useDriverDetails };
